// ============================================
// ShareButtons — Twitter/X + Copy link
// Props: url, title, label
// ============================================
import { useState } from 'react';
import styles from './ShareButtons.module.css';

function ShareButtons({ url, title, label = 'Share:' }) {
    const [copied, setCopied] = useState(false);

    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);

    const twitterHref = `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            /* fallback: no-op */
        }
    };

    return (
        <div className={styles.row}>
            {label && <span className={styles.label}>{label}</span>}

            <a
                href={twitterHref}
                target="_blank"
                rel="noopener noreferrer"
                className={`${styles.btn} ${styles.btnTwitter}`}
                aria-label="Share on X / Twitter"
            >
                <XIcon />
                <span>Post</span>
            </a>

            <button
                className={`${styles.btn} ${styles.btnCopy} ${copied ? styles.btnCopied : ''}`}
                onClick={handleCopy}
                aria-label="Copy link"
            >
                {copied ? <CheckIcon /> : <LinkIcon />}
                <span>{copied ? 'Copied!' : 'Copy link'}</span>
            </button>
        </div>
    );
}

/* ── Inline SVG icons (no extra deps) ── */
function XIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.26 5.632 5.905-5.632Zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
    );
}

function LinkIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
    );
}

function CheckIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    );
}

export default ShareButtons;